import styled from 'styled-components'

export const Content = styled.div`
    text-align: center;
    margin-bottom: 2rem;

    & > p:first-child {
        margin-bottom: 12px;
    }
`
